import React, { useState } from 'react'
import { MainContainer } from '../Components/Elements'
import AddUnitHooks from '../hooks/Units/AddUnitHooks'
import MainDropdown from '../Components/MainDropdown'
import MainInput from '../Components/MainInput'
import { Link } from 'react-router-dom'
import DateRangePickerInput from './DateRangePicker'

const AddUnit = () => {
    const {
        NavItems,
        selectedTeamName,
        teams,
        handleSelect
      } = AddUnitHooks()

    const [Thispage, setThispage] = useState("Basic")
    const linkCount = NavItems?.length;


  return <>
   <MainContainer>
    <DateRangePickerInput />
      <div className='d-flex gap-3 mb-3 align-items-center'>
      <section className='NavHub'>
    <div className='d-flex justify-content-center'>
    <div className="navContainer" style={{ width: "100%" }}>
      {NavItems.map((link, index) => (
        <label
          className="itemContainer"
          key={index}
          onClick={()=> {setThispage(link.actionText)}}
          style={{ flex: `1 0 ${100 / linkCount}%` }}
        >
          <Link
       
            className={`item ${Thispage  === link.actionText ?  "checked" : ""}`}
          >
            {link.icon && <img src={link.icon} className="icon"/>}
            {link.name}
          </Link>
        </label>
      ))}
    </div>
    </div>
  </section>
      </div>

      {Thispage === "Basic" &&  <div className='row'>
        <div className="col-md-4">
            <div>
            <MainDropdown
        label="Team"
        title={selectedTeamName ? selectedTeamName : "Select Team"}
        options={teams}
        langDir='en'
        onSelect={handleSelect}
        displayKey="name"
        forceWidth
      />
            </div>
        </div>
        <div className="col-md-4">
            <div>
            <MainDropdown
        label="Team"
        title={selectedTeamName ? selectedTeamName : "Select Team"}
        options={teams}
        langDir='en'
        onSelect={handleSelect}
        displayKey="name"
        forceWidth
      />
            </div>
        </div>
        <div className="col-md-4">
            <div>
            <MainDropdown
        label="Team"
        title={selectedTeamName ? selectedTeamName : "Select Team"}
        options={teams}
        langDir='en'
        onSelect={handleSelect}
        displayKey="name"
        forceWidth
      />
            </div>
        </div>
        <div className="col-md-4">
            <div>
            <MainDropdown
        label="Team"
        title={selectedTeamName ? selectedTeamName : "Select Team"}
        options={teams}
        langDir='en'
        onSelect={handleSelect}
        displayKey="name"
        forceWidth
      />
            </div>
        </div>
        <div className="col-md-8">
            <div>
            <MainInput forceWidht label={"Unit Number"} placeholder={"Enter Unit Number......"} required={true} type={"text"}/>
            </div>
        </div>
        <div className="col-md-12 text-end mt-3">
        <button className='btn bg-white text-main shadow-lg px-5 py-2 fw-bold' onClick={()=>{setThispage("Price")}}>Next</button>
        </div>
        </div> }
      {Thispage === "Price" &&   <div className='row'>
            <div className="col-md-6">
            <MainInput forceWidht label={"Price"} placeholder={"Enter Price......"} required={true} type={"text"}/>
            </div>
            <div className="col-md-6">
            <MainInput forceWidht label={"Deposit"} placeholder={"Enter Deposit......"} required={true} type={"text"}/>
            </div>
            <div className="col-md-12">
                <p className='fw-bold fs-7 mt-2'>Select Type*</p>
               <div className='d-flex justify-content-between w-75'>
                <div>
                <label className="radio-button">
                  <input type="radio" name="SelectTypePayment" value="Cash"/>
                  <span className="radio"></span>
                  Cash
                </label>
                </div>
             
                <div>
                <label className="radio-button">
                  <input type="radio" name="SelectTypePayment" value="Installment"/>
                  <span className="radio"></span>
                  Installment
                </label>
                </div>
               
               </div>
            </div>
            <div className="col-md-6">
            <MainInput forceWidht label={"Price"} placeholder={"Enter Price......"} required={true} type={"text"}/>
            </div>
            <div className="col-md-6">
            <MainInput forceWidht label={"Deposit"} placeholder={"Enter Deposit......"} required={true} type={"text"}/>
            </div>
            <div className="col-md-3">
            <MainInput forceWidht label={"Deposit"} placeholder={"Enter Deposit......"} required={true} type={"text"}/>
            </div>
            <div className="col-md-3">
            <MainInput forceWidht label={"Deposit"} placeholder={"Enter Deposit......"} required={true} type={"text"}/>
            </div>
            <div className="col-md-3">
            <MainInput forceWidht label={"Deposit"} placeholder={"Enter Deposit......"} required={true} type={"text"}/>
            </div>
            <div className="col-md-3">
            <MainInput forceWidht label={"Deposit"} placeholder={"Enter Deposit......"} required={true} type={"text"}/>
            </div>
            <div className="col-md-12 text-end mt-3">
        <button className='btn bg-white text-main shadow-lg px-5 py-2 fw-bold' onClick={()=>{setThispage("options")}}>Next</button>
        </div>
     </div> }
     
     
    {Thispage === "options" &&  <div className="row">
     <div className="col-md-12">
            <div>
            <MainInput forceWidht label={"Delay Penalty %"} placeholder={"Enter Delay Penalty %......"} required={true} type={"text"}/>
            </div>
        </div>
     <div className="col-md-6">
        <div className=' mt-3'>
            <p className='mb-1 fw-bold'>Delay time limit</p>
        <label className="switch">
            <input type="checkbox"/>
            <span className="slider"></span>
            </label>
        </div>

        </div>
        <div className="col-md-6">
            <div>
            <MainInput forceWidht label={"Delay time limit ( Days )"} placeholder={"Enter Delay time limit ( Days )......"} required={true} type={"text"}/>
            </div>
        </div>
     <div className="col-md-6">
        <div className=' mt-3'>
            <p className='mb-1 fw-bold'>Early settlement</p>
        <label className="switch">
            <input type="checkbox"/>
            <span className="slider"></span>
            </label>
        </div>

        </div>
        <div className="col-md-6">
            <div>
            <MainInput forceWidht label={"Discount Rate %"} placeholder={"Enter Discount Rate %......"} required={true} type={"text"}/>
            </div>
        </div>
        <div className="col-md-12 text-end mt-3">
        <button className='btn bg-white text-main shadow-lg px-5 py-2 fw-bold'>Submit</button>
        </div>
     </div>}
    </MainContainer>
  </>
}

export default AddUnit
